import { ChiptaElement, html, css } from 'chipta-libs/main.js';
import { repeat } from 'lit-html/directives/repeat.js';
import 'chipta-libs/components/ticketshop-shell.js';
import 'chipta-libs/components/ticketshop-header.js';
import 'chipta-libs/components/font-awesome.js';
import 'chipta-libs/components/styled-button.js';
import { layoutStyles } from 'chipta-libs/styles/layout.js';
import eventsState from './state/events.js';
import groupState from './state/group.js';
import './event-details.js';
import './event-group-details.js';
import './events-geo-filter.js';


class EventsOverview extends layoutStyles(ChiptaElement) {

  render() {

    return html`

      <ticketshop-shell>

        <ticketshop-header headertext=${this.headerText}>
          <div class="content">
            ${this.contents}
          </div>
        </ticketshop-header>

      </ticketshop-shell>

    `;

  }

  get headerText() {
    return interpolate(
      gettext('tickets_of'),
      {organizername: _ticketshopData.public_name},
      true
    );
  }

  get contents() {
    return html`
      ${this.backButton}
      ${this.geoFilter}
      ${this.list}
    `;
  }

  get list() {
    if (eventsState.events.length) {
      return html`<div id="list">${this.listItems}</div>`;
    } else {
      return html`<div id="no-events">${gettext('no_events_on_sale')}</div>`;
    }
  }

  get backButton() {

    if (!groupState.selectedGroup) {
      return;
    }

    return html`

      <div>

        <styled-button type="secondary" id="back-to-groups" @click=${this.clearSelectedGroup}>
          <button>
            <font-awesome icon="chevron-left"></font-awesome>
            <span id="back-to-groups-text">${gettext('back')}</span>
          </button>
        </styled-button>

      </div>

    `;

  }

  get geoFilter() {
    if (_ticketshopData.events_geo_filter_settings) {
      return html`<events-geo-filter></events-geo-filter>`;
    }
  }

  get listItems() {

    if (groupState.selectedGroup) {
      return this.getEventList(groupState.selectedGroup.events);
    }

    if (_ticketshopData.event_groups) {
      return this.getGroupList();
    }

    return this.getEventList();

  }

  getGroupList() {
    return repeat(
      _ticketshopData.event_groups.children,
      (group, index) => {
        return html`
          <event-group-details
            .group=${group}
            ?odd=${index % 2 == 0}
          ></event-details-details>
        `;
      }
    );
  }

  getEventList(eventIds) {

    let events = eventsState.events;

    if (eventIds) {
      events = events.filter(event => eventIds.indexOf(event.id) !== -1);
    }

    return repeat(
      events,
      (eventData, index) => {
        return html`
          <event-details
            .eventData=${eventData}
            ?odd=${index % 2 == 0}
          ></event-details>
        `;
      }
    );

  }

  static get styles() {

    return css`

      :host {
        display: block;
        height: 100%;
      }

      #list {
        border: 1px solid #D9D9D9;
      }

      #no-events {
        padding: 25px 0;
        text-align: center;
      }

      event-details[odd],
      event-group-details[odd] {
        background: #F7F7F7;
      }

      #back-to-groups {
        margin-bottom: 15px;
        font-size: 18px;
      }

      #back-to-groups-text {
        margin-left: 5px;
      }

      events-geo-filter {
        margin-bottom: 15px;
      }

    `;

  }

  clearSelectedGroup() {
    groupState.selectedGroup = null;
  }

}

customElements.define('events-overview', EventsOverview);
